export const FETCH_CUSTOMER_PORTFOLIO_ITEMS =
  'iron/profile/FETCH_CUSTOMER_PORTFOLIO_ITEMS';
export const FETCH_CUSTOMER_PORTFOLIO_ITEMS_SET =
  'iron/profile/FETCH_CUSTOMER_PORTFOLIO_ITEMS_SET';

export const SET_CUSTOMER_PORTFOLIO_ITEMS =
  'iron/profile/SET_CUSTOMER_PORTFOLIO_ITEMS';
export const TOGGLE_ITEM_SELECT = 'iron/profile/TOGGLE_ITEM_SELECT';
export const REMOVE_ITEM = 'iron/profile/REMOVE_ITEM';
export const SET_PROFILE_LOADING = 'iron/profile/SET_PROFILE_LOADING';
export const SET_PROFILE_ERROR = 'iron/profile/SET_PROFILE_ERROR';
export const FETCH_CUSTOMER_BUYING_STATS =
  'iron/profile/FETCH_CUSTOMER_BUYING_STATS';
export const FETCH_CUSTOMER_SELLING_STATS =
  'iron/profile/FETCH_CUSTOMER_SELLING_STATS';
export const SET_CUSTOMER_BUYING_STATS =
  'iron/profile/SET_CUSTOMER_BUYING_STATS';
export const SET_CUSTOMER_SELLING_STATS =
  'iron/profile/SET_CUSTOMER_SELLING_STATS';
export const CLEAR_SELECTED_ITEMS = 'iron/profile/CLEAR_SELECTED_ITEMS';
export const SET_CUSTOMER_SELLING_ITEM_IDS =
  'iron/profile/SET_CUSTOMER_SELLING_ITEM_IDS';
export const DUMP_PORRTFOLIO_ITEMS = 'iron/profile/DUMP_PORRTFOLIO_ITEMS';
export const SET_SELECTED_ITEMS = 'iron/profile/SET_SELECTED_ITEMS';
export const CLEAR_ITEMS = 'iron/profile/CLEAR_ITEMS';
export const SET_PORTFOLIO_ITEM_SHIP_BY_DATE =
  'iron/profile/SET_PORTFOLIO_ITEM_SHIP_BY_DATE';

export const toggleItemSelect = (item) => ({
  type: TOGGLE_ITEM_SELECT,
  payload: { item },
});

export const setSelectedItems = (items) => ({
  type: SET_SELECTED_ITEMS,
  payload: { items },
});

export const clearSelectedItems = () => ({
  type: CLEAR_SELECTED_ITEMS,
});

export const removeItem = ({ chainId }) => ({
  type: REMOVE_ITEM,
  payload: { chainId },
});

export const fetchCustomerPortfolioItems = ({
  customerId,
  type,
  status,
  limit,
  page,
  sort,
  order,
  search,
  currency,
  marketName,
}) => ({
  type: FETCH_CUSTOMER_PORTFOLIO_ITEMS,
  payload: {
    customerId,
    type,
    status,
    limit,
    page,
    sort,
    order,
    search,
    currency,
    marketName,
  },
});

export const setCustomerPortfolioItems = ({
  items,
  paging,
  type,
  status,
  search,
}) => ({
  type: SET_CUSTOMER_PORTFOLIO_ITEMS,
  payload: {
    items,
    paging,
    type,
    status,
    search,
  },
});

export const setProfileLoading = ({ type, status }) => ({
  type: SET_PROFILE_LOADING,
  payload: {
    type,
    status,
  },
});

export const setProfileError = ({ type, status, errorText }) => ({
  type: SET_PROFILE_ERROR,
  payload: { errorText, type, status },
});

export const fetchCustomerBuyingStats = (currency = 'USD') => ({
  type: FETCH_CUSTOMER_BUYING_STATS,
  payload: { currency },
});

export const fetchCustomerSellingStats = (currency) => ({
  type: FETCH_CUSTOMER_SELLING_STATS,
  payload: { currency },
});

export const setCustomerBuyingStats = ({ buying }) => ({
  type: SET_CUSTOMER_BUYING_STATS,
  payload: { buying },
});

export const setCustomerSellingStats = ({ selling }) => ({
  type: SET_CUSTOMER_SELLING_STATS,
  payload: { selling },
});

export const fetchCustomerPortfolioItemsSet = ({
  customerId,
  type,
  currency,
}) => ({
  type: FETCH_CUSTOMER_PORTFOLIO_ITEMS_SET,
  payload: {
    customerId,
    type,
    currency,
  },
});

export const clearItems = () => ({
  type: CLEAR_ITEMS,
  payload: {},
});

export const setExtendedShipByDate = ({
  chainId,
  extendedShipByDate,
}: {
  chainId: string;
  extendedShipByDate: string;
}) => ({
  type: SET_PORTFOLIO_ITEM_SHIP_BY_DATE,
  payload: {
    chainId,
    extendedShipByDate,
  },
});
